// extracted by mini-css-extract-plugin
export var quillEditor = "_oy-1";
export var variable = "_oy-0";